<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
<!--    <van-sticky>-->
<!--      <div class="step-box">-->
<!--        <van-steps :active="active">-->
<!--          <van-step>第一步</van-step>-->
<!--          <van-step>第二步</van-step>-->
<!--          <van-step>第三步</van-step>-->
<!--        </van-steps>-->
<!--      </div>-->
<!--    </van-sticky>-->
    <div v-if="loading">
      <van-form
          v-if="active == 0"
          @submit="onSubmit"
          @failed="onFailed"
      >
        <van-cell-group>
          <van-field
              readonly
              clickable
              v-if='false'
              :value="formData.extra_saiqu.length ? formData.extra_saiqu[0].name : ''"
              autosize
              type="textarea"
              input-align="right"
              label="选择领取的比赛名称"
              placeholder="点击选择领取的比赛名称"
              @click="showSaiquPicker = true"
          />
          <SaiquPicker
              :show="showSaiquPicker"
              :limit="1"
              :value="formData.extra_saiqu"
              @onChange="onSaiquChange"
              @onClose="showSaiquPicker=false"
              :defaultValue="formData.extra_saiqu"
              @onConfirm="onSaiquConfirm"
          ></SaiquPicker>

          <van-field
              readonly
              clickable
              name="area"
              :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
              input-align="right"
              label="地区选择"
              placeholder="点击选择省市区"
              @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                :value="formData.area"
                @confirm="onAreaConfirm"
                @cancel="showArea = false"
            />
          </van-popup>

          <van-field
              v-model="formData.shenbaodanwei"
              :rules="[{ required: true, message: '单位名称不能为空' }]"
              label="申报单位"
              input-align="right"
              error-message-align="right"
              clearable
              placeholder="请输入单位名称"
          />
          <van-field
              v-model="formData.danwei"
              :rules="[{ required: true, message: '不能为空' }]"
              label="俱乐部名称"
              input-align="right"
              error-message-align="right"
              clearable
              placeholder="请输入俱乐部名称"
          />
          <van-field name="radio" label="类型"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.clubleixing" direction="horizontal">
                <van-radio checked-color="#ffb01b" name="社会俱乐部">社会俱乐部</van-radio>
                <van-radio checked-color="#ffb01b" name="学校俱乐部">学校俱乐部</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" label="申报等级"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.bgrade">
                              <van-radio checked-color="#ffb01b" name="一星">一星</van-radio>
<!--                <van-radio checked-color="#ffb01b" name="二星">二星</van-radio>-->
<!--                <van-radio checked-color="#ffb01b" name="三星">三星</van-radio>-->
<!--                <van-radio checked-color="#ffb01b" name="四星">四星</van-radio>-->
<!--                <van-radio checked-color="#ffb01b" name="五星">五星</van-radio>-->
              </van-radio-group>
            </template>
          </van-field>

          <van-field
              v-model="formData.chandimianji"
              label="场地面积"
              :rules="[{ required: true, message: '场地面积不能为空' }]"
              error-message-align="right"
              type="number"
              input-align="right"
              clearable
              placeholder="请输入场地面积（平米）"
          />


          <van-field
              v-model="formData.yundongyuanrenshu"
              :rules="[{ required: true, message: '人数不能为空' }]"
              error-message-align="right"
              label="拟注册运动员人数"
              type="number"
              input-align="right"
              clearable
              placeholder="请输入人数"
          />


          <van-field
              v-model="formData.address"
              :rules="[{ required: true, message: '请输入详细地址' }]"
              error-message-align="right"
              label="详细地址"
              input-align="right"
              clearable
              placeholder="请输入详细地址"
          />


          <!--        <van-cell title="申报表" :value="formData.shenbaozip.length+'/1'">-->
          <!--          <template slot="icon">-->
          <!--          </template>-->
          <!--        </van-cell>-->

          <!--        <div class="row" v-if="false">-->
          <!--          <PicUploader :fileList="formData.shenbaozip" :limit="1"-->
          <!--                       :name="'shenbaozip'"></PicUploader>-->
          <!--        </div>-->
          <!--        <div v-if="false" class="operate-desc-left">申报表模版下载</div>-->


          <van-cell title="场地照片" :value="formData.changdipic.length+'/5'">
          </van-cell>

          <div class="row">
            <PicUploader :fileList="formData.changdipic" :limit="5"
                         :name="'changdipic'"></PicUploader>
          </div>
          <div class="operate-desc-left">上传5张场地照片</div>


        </van-cell-group>


        <van-divider>负责联系人信息</van-divider>

        <van-cell-group>

          <van-field
              v-model="formData.nickname"
              :rules="[{ required: true, message: '请输入姓名' }]"
              error-message-align="right"
              label="姓名"
              input-align="right"
              clearable
              placeholder="请输入姓名"
          />


          <van-field
              v-model="formData.certificatenumber"
              :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
              error-message-align="right"
              label="身份证号"
              input-align="right"
              clearable
              placeholder="请输入身份证号"
          />


          <!--        <van-field-->
          <!--            v-model="formData.email"-->
          <!--            :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"-->
          <!--            error-message-align="right"-->
          <!--            label="邮箱"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入邮箱"-->
          <!--        />-->


          <van-field
              v-model="formData.phone"
              :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
              error-message-align="right"
              label="手机"
              input-align="right"
              clearable
              placeholder="请输入手机"
          />

          <!--        <van-field-->
          <!--            v-model="formData.qq"-->
          <!--            label="QQ"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入QQ"-->
          <!--        />-->

          <!--        <van-field-->
          <!--            v-model="formData.weixin"-->
          <!--            label="微信号"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入微信号"-->
          <!--        />-->

        </van-cell-group>

        <van-divider>日常联系人信息
        </van-divider>

        <van-cell-group>

          <van-field
              v-model="formData.contactsname"
              :rules="[{ required: true, message: '请输入姓名' }]"
              error-message-align="right"
              label="姓名"
              input-align="right"
              clearable
              placeholder="请输入姓名"
          />


          <van-field
              v-model="formData.contactscertificatenumber"
              :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
              error-message-align="right"
              label="身份证号"
              input-align="right"
              clearable
              placeholder="请输入身份证号"
          />


          <van-field
              v-model="formData.contactsemail"
              :rules="[{ validator: validator.email,message:'请输入正确的邮箱'}]"
              error-message-align="right"
              label="邮箱"
              input-align="right"
              clearable
              placeholder="请输入邮箱"
          />

                 <van-field
                     v-model="formData.contactsweixin"
              :rules="[{ required: true, message: '请输入微信号' }]"
                     label="微信号"
                     input-align="right"
                     clearable
                     placeholder="请输入微信号"
                 />

          <van-field
              v-model="formData.contactsphone"
              :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
              error-message-align="right"
              label="手机"
              input-align="right"
              clearable
              placeholder="请输入手机"
          />

                        <van-field
                                v-model="formData.phonecode"
                                label="验证码"
                                :rules="[{ required: true,message:'请输入验证码'}]"
                                error-message-align="right"
                                input-align="right"
                                clearable
                                placeholder="请输入验证码"
                        >
                        <template #button>
                        <van-button @click="getCode" native-type="button" size="small" type="primary" :disabled="clockSecond>0">{{clockSecond>0?
                    '('+clockSecond+'s)':'获取验证码'}}</van-button>
                        </template>
                        </van-field>

          <!--        <van-field-->
          <!--            v-model="formData.contactsqq"-->
          <!--            label="QQ"-->
          <!--            input-align="right"-->
          <!--            clearable-->
          <!--            placeholder="请输入QQ"-->
          <!--        />-->


        </van-cell-group>

        <div class="savebtn">
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
            提交申请
          </van-button>
        </div>
      </van-form>

      <div class="step-two" v-if="active == 1">
        <van-cell-group>
          <ul class="step-two-box">
            <li>提交申报信息成功！</li>
            <li>审核工作会在24小时内完成。</li>
          </ul>

        </van-cell-group>
        <div class="savebtn">
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round @click="fetch">我知道了
          </van-button>
        </div>
      </div>
<!--      <div class="step-three" v-if="active == 2">-->
<!--        <van-form-->
<!--            @submit="onSubmitThree"-->
<!--            @failed="onFailed"-->
<!--        >-->
<!--          <van-cell-group>-->
<!--            <div class="step-three-title">确认验收信息</div>-->
<!--            <div class="step-three-text">-->
<!--              <div style="margin-bottom: .3rem">请确认您的建设清单：</div>-->
<!--              <div class="step-three-li">一星：无器材要求</div>-->
<!--              <div class="step-three-li">二星：幼儿园、小学、中学、大学、成年</div>-->
<!--              <div class="step-three-li">三星：幼儿园、小学、中学、大学、成年</div>-->
<!--              <div class="step-three-li">四星：幼儿园、小学、中学、大学、成年</div>-->
<!--              <div class="step-three-li">五星：幼儿园、小学、中学、大学、成年</div>-->
<!--            </div>-->

<!--            <van-cell title="图片证明">-->
<!--            </van-cell>-->
<!--            <div class="row">-->
<!--              <FileUploader uploadText="图片证明" :fileList="formData.yanshou_pic" :limit="1" accept=".zip,.rar,.xls,.xlsx"-->
<!--                            :name="'yanshou_pic'"></FileUploader>-->
<!--            </div>-->
<!--            <div class="operate-desc-left">建议打包上传一个压缩包文件</div>-->
<!--            <van-cell title="点击上传验收图片">-->
<!--            </van-cell>-->

<!--            <div class="row">-->
<!--              <PicUploader :fileList="formData.yanshoubiao_pic" :limit="5"-->
<!--                           :name="'yanshoubiao_pic'"></PicUploader>-->
<!--            </div>-->
<!--          </van-cell-group>-->
<!--          <div class="savebtn">-->
<!--            <van-button-->
<!--                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"-->
<!--                style="width: 3rem"-->
<!--                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">-->
<!--              保存-->
<!--            </van-button>-->
<!--          </div>-->
<!--        </van-form>-->
<!--      </div>-->
      <div class="step-three" v-if="active == 2">
        <van-form
            @submit="onSubmitThree"
            @failed="onFailed"
        >
          <van-cell-group>
            <div class="step-three-title">审核成功</div>
            <div class="step-three-text">
              <div class="step-three-li">您已获得 </div>
              <div class="step-three-li">全国啦啦操一星俱乐部授权</div>
              <div class="step-three-li">全国啦啦操七彩星级指定考级点授权</div>
            </div>
<!--            <van-cell title="点击上传验收图片">-->
<!--            </van-cell>-->

<!--            <div class="row">-->
<!--              <PicUploader :fileList="formData.yanshoubiao_pic" :limit="5"-->
<!--                           :name="'yanshoubiao_pic'"></PicUploader>-->
<!--            </div>-->
          </van-cell-group>
          <div class="savebtn">
            <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
              前往主页
            </van-button>
          </div>
        </van-form>
      </div>
      <van-dialog v-model="showPay" title="收款账户" :show-confirm-button="false" :close-on-click-overlay="true">
        <div style="width: 80%; text-align: center ; margin: 0px auto 20px;  font-size:14px;">
          <img style="width: 100%;" src=""/>
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round @click="onPayDownload">下载二维码
          </van-button>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<style scoped>
.step-box {
  margin: 0 .2rem .2rem;
}

.step-two-box {
  padding: .4rem .2rem;
  font-size: 16px;
}

.step-two-box li {
  margin-bottom: .3rem;
}


.step-three-title {
  font-size: 24px;
  padding: .3rem 0;
  text-align: center;
}

.step-three-text {
  margin: 0 .3rem;
  font-size: 14px;
}

.step-three-danwei {
  margin: .1rem 0 .3rem;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubApplyMine',
  components: {
    PicUploader, FileUploader, SaiquPicker
  },
  data: function () {
    return {
      validator,
      active: 0,
      loading: false,
      showPay: false,
      saveLoading: false,
      showArea: false,
      showSaiquPicker: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
        bgrade: '一星',
//                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        changdipic: [],
        shenbaozip: [],
        yanshoubiao_pic: [],
//                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        zhizhaopic: [],
        extra_saiqu: [],

      clockSecond:0,
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = "俱乐部申请"
//            if(that.formData.id){
    this.fetch();
//            }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onSaiquChange(values) {
      console.log('onSaiquChange', values)
      this.formData.extra_saiqu = [...values];
    },
    onSaiquConfirm(values) {
      console.log('onJianduConfirm', values)
      this.showSaiquPicker = false;
      this.formData.extra_saiqu = [...values];
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      for (let field in that.formData) {

        if (that.formData.changdipic.length != 5) {
          Toast('请上传5张场地照片');
          return
        }
        if (that.formData.shenbaozip.length == 0) {
          // Toast('请上传申报表');
          // return
        }
        if (!that.formData.bgrade) {
          Toast('请选择等级');
          return
        }
        if (!that.formData.clubleixing) {
          Toast('请选择俱乐部类型');
          return
        }
        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
      }
      that.saveLoading = true;

      if (that.submitType == 'save') {
        that.$api.post('/api/examecenter/save', that.formData, (res) => {
          that.saveLoading = false;
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      } else {

        that.formData.stationid = that.formData.extra_saiqu.length ? that.formData.extra_saiqu[0].id :0

        that.$api.post('/api/club/apply', that.formData, (res) => {
          that.saveLoading = false;

          // 跳转改为步骤条进行
          that.active = 1
          return
          rbLink({
            name: "CertClubResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        }, (res) => {
          Toast.fail(res.msg);
          that.saveLoading = false;
        })
      }
    },

    onPayDownload() {
      this.download({
        name: '啦啦操收款二维码',
        url: ''
      })
    },

    download(file){
      appEvent({
        name: 'downloadFile',
        query: {
          name:file.name,
          url:file.url,
        }
      });
    },

    onSubmitThree(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;

      console.log(that.formData, that.submitThreeType)

      // 回到俱乐部详情页面
      rbLink({
        name: 'ClubDetail',
        query: {
          id: that.formData.id
        }
      }, 'replace')
      return

      if(that.submitThreeType == 'show' ) return
      that.formValidate = true;


      for (let field in that.formData) {

        if (that.formData.changdipic.length != 5) {
          Toast('请上传5张场地照片');
          return
        }
        if (that.formData.shenbaozip.length == 0) {
          // Toast('请上传申报表');
          // return
        }
        if (!that.formData.bgrade) {
          Toast('请选择等级');
          return
        }
        if (!that.formData.clubleixing) {
          Toast('请选择俱乐部类型');
          return
        }
        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }
      }
      that.saveLoading = true;

      that.$api.post('/api/club/yanshouSave', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('保存成功')

        rbLink({
          name:"ClubIndex",
        },'back')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })

    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },

    // 我要付款
    onPay() {
      this.submitThreeType = 'show'
      this.showPay = true
    },
    submit(values) {
      this.submitType = 'submit';
      this.submitThreeType = 'submit'
    },
    fetch() {
      let that = this;
      that.$api.post('/api/club/clubdetail', {
        id: that.formData.id
      }, (res) => {
        that.loading = true
        that.formData = res.data;
        if (res.data.registstatus == 1) {
          that.active = 1;
          return;
          rbLink({
            name: "ClubResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        } else if (res.data.registstatus == 2) {
          that.active = 2;
        }
      }, (res) => {
        that.loading = true
//                    Toast.fail(res.msg);
      })
    },

            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return;
                }
                if (!that.formData.contactsphone) {
                    Toast('请输入手机号')
                    return;
                }
                /*if (!that.formData.code) {
                    Toast('请输入验证码')
                    return;
                }*/
                that.$api.get('/api/index/phonecode', {phone: that.formData.contactsphone}, (res) => {
                    Toast(res.msg);
                })

                that.clockSecond = 60;

                var t = setInterval(function () {
                    if (that.clockSecond > 0) {
                        that.clockSecond = that.clockSecond - 1;
                    } else {
                        clearInterval(t);
                    }
                }, 1000)
            }

  }
}
</script>



// WEBPACK FOOTER //
// ClubApplyMine.vue?d8f93418